import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';

import { wlPath } from '../../helpers/whitelabel';
import { signOutUser } from '../../actions/userActions';
import { logEvent } from '../../helpers/analytics';

class ResetOnboarding extends Component {
  _signout(e) {
    e.preventDefault();
    // console.log(`${window.location.origin}${wlPath('')}`);
    logEvent('StartNewPlan');
    this.props.signOutUser(wlPath(''));
  }

  render() {
    return (
      <Fragment>
        <Typography use="body1" tag="div">
          Want to update your information?
        </Typography>
        <Typography use="body1" tag="div">
          <a href="#" onClick={this._signout.bind(this)}>
            Start New Plan Preview
          </a>
        </Typography>
      </Fragment>
    );
  }
}

export default connect(null, { signOutUser })(ResetOnboarding);
